import { CommonData } from "../datastructures/gamestate/gameData";

export class logoOverlay {
    private parent:PIXI.Container;
    private parentLogoIntro:PIXI.Container;
    // private logoFrame: PIXI.Sprite;
    private logoBG: PIXI.Sprite;
    private desktopLogo: PIXI.Sprite;
    private activeGameData: CommonData;
    private sideLogo:PIXI.Sprite;
    // private logoPortrait:PIXI.Sprite;
    constructor(parent:PIXI.Container,logoName:string,activeGameData:CommonData,enableMobileLogo:boolean,enableFrame:boolean=true) {
        // console.log('load')
        this.parent= new PIXI.Container;
        parent.addChild(this.parent)
        this.parentLogoIntro= new PIXI.Container;
       
        this.logoBG = new PIXI.Sprite(PIXI.Texture.fromImage("gambleBG.png"));
        this.activeGameData=activeGameData;
        this.desktopLogo = new PIXI.Sprite(PIXI.Texture.fromImage(logoName));
        this.desktopLogo.anchor.set(.5, 0);//--log displayed ingame Portrait
        this.sideLogo = new PIXI.Sprite(PIXI.Texture.fromImage(logoName));

        // console.log(enableMobileLogo)
        if (this.activeGameData.isMobile && enableMobileLogo) {
           
            this.parent.addChild( this.sideLogo);
            this.sideLogo.anchor.set(.5);
            this.sideLogo.scale.set(.5);

            this.setMobilePosition([this.sideLogo.width/2-70,this.activeGameData.size[1] - 180])

            this.logoBG.anchor.set(.5)
            this.logoBG.width = 1400;
            this.logoBG.height = 800
            this.logoBG.position.set(this.activeGameData.size[0] / 2, this.activeGameData.size[1] / 2);

          
            this.desktopLogo.anchor.set(.5);
            this.desktopLogo.position.set(this.activeGameData.size[0] / 2, this.activeGameData.size[1] / 2);
            // this.logoBG.addChild(this.desktopLogo);
            this.desktopLogo.scale.set(1);

            let tweenLogoText = PIXI.tweenManager.createTween(this.desktopLogo);
            tweenLogoText.from({ scale: { x: 2, y: 2 }, alpha: 1, y: this.desktopLogo.y - 100 }).to({ scale: { x: 1.5, y: 1.5 }, alpha: 1, y: this.desktopLogo.y });
            tweenLogoText.time = 1000;
            // tweenLogoText.loop = true;
            tweenLogoText.easing = PIXI.tween.Easing.outBack();

            tweenLogoText.start();

            let tweenLogoTextFadeOut = PIXI.tweenManager.createTween(this.parentLogoIntro);
            tweenLogoTextFadeOut.to({ y: this.logoBG.y - 50, alpha: 0 });
            tweenLogoTextFadeOut.time = 1000;
            tweenLogoTextFadeOut.delay = 2000;
            tweenLogoTextFadeOut.easing = PIXI.tween.Easing.inExpo();

            tweenLogoTextFadeOut.start();

            //--create  game logoFrame with desktopLogoInside
            this.parent.addChild(this.parentLogoIntro);
            if(enableFrame)
            {
                this.parentLogoIntro.addChild(this.logoBG);
            }
           
            this.parentLogoIntro.addChild(this.desktopLogo)
        }

        else {

            this.desktopLogo.scale.set(.75);
            this.setDesktopPosition([this.activeGameData.size[0] / 2, 75]);
            this.parent.addChild(this.desktopLogo);
        
        }

 
    }

    public getDesktopLogo=():PIXI.Sprite=>{
        return this.desktopLogo;
    }

    public getSideLogo=():PIXI.Sprite=>{
        return this.sideLogo;
    }

    public setMobilePosition=(pos:Array<number>):void=>
    {
        this.sideLogo.position.set(pos[0],pos[1]);
    }

    public setDesktopPosition=(pos:Array<number>):void=>
    {
        this.desktopLogo.position.set(pos[0],pos[1]);
    }
    public getAnimatedParent=():PIXI.Container=>
    {
        return  this.parentLogoIntro;
    }
    public setMobileSideLogo=(val:number):void=>
    {
        this.sideLogo.scale.set(val);
    }


    public setMobileScale=(val:number):void=>
    {
        // this.desktopLogo.scale.set(val);
        this.sideLogo.scale.set(val)
        // console.log('logoScale',val)
    }

    public setDesktopScale=(val:number):void=>
    {
        this.desktopLogo.scale.set(val);
    }

    public getLogoBG=():PIXI.Sprite=>
    {
        return this.logoBG;
    }
    public setNewBGTexture=(imgName:string):void=>
    {
        this.logoBG.texture= PIXI.Texture.fromFrame(imgName+'.png');
    }
    public onResize=():void=>
    {
        if(this.activeGameData.isInPortraitMode && this.activeGameData.isInPortraitMode)
        {
            this.setVisible(false);
        }
        else
        {
             this.setVisible(true);    
         }
    }
    private setVisible=(bool:boolean):void=>
    {   
        let nAlpha=bool?1:0;
        if( this.sideLogo!=undefined)
        {
            this.sideLogo.alpha=nAlpha;
        }
      
        
    }

    public getMobileFrame=():PIXI.Sprite=>
    {
        return this.logoBG;
    }
    
    public getParent=():PIXI.Container=>
    {
        return this.parent;
    }
}